import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'
import FormSmartSelect from './components/form/FormSmartSelect.vue'
import FormulateToggle from './components/form/FormulateToggle.vue'

// register your component with Vue
Vue.component('FormSmartSelect', FormSmartSelect)
Vue.component('FormulateToggle', FormulateToggle)

Vue.use(VueFormulate, {
  classes: {
    // outer: '',
    // input: '',
    // wrapper: '',
    // element: '',
    label: 'text-gray-700 font-semibold text-base ml-2 mb-1 inline-block',
    help: 'text-cool-gray-500 font-light text-sm ml-1',
    error: 'text-red-700 font-light text-sm ml-1'
  },
  library: {
    smartselect: {
      classification: 'select',
      component: 'FormSmartSelect'
    },
    toggle: {
      classification: 'radio',
      component: 'FormulateToggle'
    }
  }
})

export { default as Worklife } from './layouts/Worklife.vue'
export { default as ModalContainer } from './components/ModalContainer.vue'
export { default as DateFormat } from './components/ui/DateFormat.vue'

export { default as FormWrapper } from './components/form/FormWrapper.vue'
export { default as FormButton } from './components/form/FormButton.vue'
export { default as FormSelect } from './components/form/FormSelect.vue'
export { default as FormInput } from './components/form/FormInput.vue'
export { default as FormTextarea } from './components/form/FormTextarea.vue'
export { default as FormCheckbox } from './components/form/FormCheckbox.vue'
export { default as FormRadio } from './components/form/FormRadio.vue'

export { default as CalendarPicker } from './components/form/Calendar/components/CalendarPicker.vue'
export { default as DatePicker } from './components/form/DatePicker.vue'

export { default as FormFile } from './components/form/FormFile.vue'
export { default as FormEmployeeLookup } from './components/form/FormEmployeeLookup.vue'
export { default as FormToggle } from './components/form/FormToggle.vue'

export { default as Navbar } from './components/ui/Navbar.vue'
export { default as MenuDropdown } from './components/ui/MenuDropdown.vue'
export { default as MenuItem } from './components/ui/MenuItem.vue'

Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})
